// Care Net shared constants + deep-link helper.
// Primary auth: short-lived JWT fetched from /api/auth/carenet/sso-token so
// returning doctors are auto-signed-in with zero typing. Falls back to the
// email hint if the token fetch fails. For signed-out visitors we hit the
// clean base URL.

import api from "@/lib/api";

export const CARE_NET_BASE = "https://doctor-approve.emergent.host";
export const CARE_NET_LOGO = "/care-net-logo.png";

/** Build the URL from a token (used after a successful fetch). */
export function careNetUrlWithToken(token) {
  if (!token) return CARE_NET_BASE;
  const sep = CARE_NET_BASE.includes("?") ? "&" : "?";
  return `${CARE_NET_BASE}${sep}sso=${encodeURIComponent(token)}&source=arogya-pramana`;
}

/** Email-only fallback (signed-in, token fetch failed). */
export function careNetUrl(user) {
  if (!user || !user.email) return CARE_NET_BASE;
  const sep = CARE_NET_BASE.includes("?") ? "&" : "?";
  return `${CARE_NET_BASE}${sep}email=${encodeURIComponent(user.email)}&source=arogya-pramana`;
}

/** Fetch a fresh SSO JWT (5-min TTL). Returns null for signed-out visitors or
 * on any backend failure — callers should fall back to `careNetUrl(user)`. */
export async function fetchCareNetSsoToken() {
  try {
    const { data } = await api.get("/auth/carenet/sso-token");
    return data.token || null;
  } catch {
    return null;
  }
}
